import { useContext } from 'react';
import CourseEditingContext from '../context/CourseEditingContext';

const useCourseEditing = () => useContext(CourseEditingContext);

export default useCourseEditing;
